import { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { SMLRoutes } from '../../../routing/sml/SMLRoutes';
import { useSMLRouter } from '../../../routing/sml/hooks';
import { Breadcrumbs } from '../../smartLinks/smlBreadcrumbs/types';
import { smlNavigationGroupMessages } from '../navigation/smlNavigationMessages';
import { chartsTabLabels, ChartsTabScreen } from './chartsTabs';
import { chartsMessages } from './chartsMessages';

/**
 * The crumbs of a page under Charts: Discover / Charts / Artists / Chappell Roan (design
 * navigation-v2 e 5c). A public share link shows the crumbs without links.
 */
export function useChartsDetailCrumbs(tab: ChartsTabScreen, name: string, isPublicMode: boolean): Breadcrumbs {
  const intl = useIntl();
  const router = useSMLRouter();
  return useMemo(
    () => [
      { name: intl.formatMessage(smlNavigationGroupMessages.publicName) },
      {
        name: intl.formatMessage(chartsMessages.title),
        onClick: isPublicMode ? undefined : () => router.push(SMLRoutes.trends),
      },
      {
        name: intl.formatMessage(chartsTabLabels[tab]),
        onClick: isPublicMode ? undefined : () => router.push(SMLRoutes[tab]),
      },
      { name },
    ],
    [intl, isPublicMode, name, router, tab]
  );
}
